KXL.module('Common.Utils.Animation', function(Animation, KXL, Backbone, Marionette, $, _) {
	Animation.calculateAnimateDuration =function (distance, speed) {
		return distance / speed;
	};
	Animation.calculateAnimateSpeed = function (distance, time) {
		return distance / time;
	};
});
